module.exports = __webpack_public_path__ + "app/img/Bethesda.3a50f69f99.svg";